import { render, staticRenderFns } from "./ValidatorStatus.vue?vue&type=template&id=1a9847fc&scoped=true&"
import script from "./ValidatorStatus.vue?vue&type=script&lang=js&"
export * from "./ValidatorStatus.vue?vue&type=script&lang=js&"
import style0 from "./ValidatorStatus.vue?vue&type=style&index=0&id=1a9847fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9847fc",
  null
  
)

export default component.exports